import { render, staticRenderFns } from "./echarts_renyuan.vue?vue&type=template&id=5bf9a165&scoped=true&"
import script from "./echarts_renyuan.vue?vue&type=script&lang=js&"
export * from "./echarts_renyuan.vue?vue&type=script&lang=js&"
import style0 from "./echarts_renyuan.vue?vue&type=style&index=0&id=5bf9a165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9a165",
  null
  
)

export default component.exports